import { SelectChangeEvent } from '@mui/material';
import { useState } from 'react';
import { GeneralSettingsParams } from '../../../../../../stores/GeneralSettings/generalSettings.types';
import { onlyNumbers } from '../../../../../../utils/validators';
import { OrderBillingForecastPreOrder } from '../../../../../orders/interfaces/order-billing-forecast/order-billing-forecast-pre-order.interfaces';
import { OrderBillingForecastReadyForDelivery } from '../../../../../orders/interfaces/order-billing-forecast/order-billing-forecast-ready-for-delivery.interfaces';
import { handleChangeAndBlurParams } from '../../../../types/generalSettingsPage.types';
interface UseOrderBillingForecastParams {
  generalSettings: GeneralSettingsParams;
  handleChangeAndBlur: (params: handleChangeAndBlurParams) => void;
}

const useOrderBillingForecast = ({
  generalSettings,
  handleChangeAndBlur,
}: UseOrderBillingForecastParams) => {
  const [readyForDeliveryDays, setReadyForDeliveryDays] = useState(
    generalSettings.billingForecastRuleForReadyForDelivery?.numberOfDays,
  );

  const [preOrderDays, setPreOrderDays] = useState(
    generalSettings.billingForecastRuleForPreOrder?.numberOfDays,
  );

  const parseNumericValue = (targetValue: string) => {
    const valueWithOnlyNumbers = onlyNumbers(targetValue);

    if (valueWithOnlyNumbers === '') {
      return null;
    }

    return +valueWithOnlyNumbers;
  };

  const handleReadyForDeliveryDaysChange = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => {
    setReadyForDeliveryDays(parseNumericValue(event.target.value));
  };

  const handleReadyForDeliveryTypeChange = (event: SelectChangeEvent<unknown>) => {
    handleChangeAndBlur({
      value: event.target.value
        ? ({
            billingForecastReadyForDeliveryType: event.target.value,
            numberOfDays: null,
          } as OrderBillingForecastReadyForDelivery)
        : null,
      name: 'billingForecastRuleForReadyForDelivery',
    });
  };

  const handleReadyForDeliveryDaysBlur = () => {
    handleChangeAndBlur({
      value: {
        billingForecastReadyForDeliveryType:
          generalSettings.billingForecastRuleForReadyForDelivery
            ?.billingForecastReadyForDeliveryType,
        numberOfDays: readyForDeliveryDays,
      } as OrderBillingForecastReadyForDelivery,
      name: 'billingForecastRuleForReadyForDelivery',
    });
  };

  const handlePreOrderDaysChange = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => {
    setPreOrderDays(parseNumericValue(event.target.value));
  };

  const handlePreOrderTypeChange = (event: SelectChangeEvent<unknown>) => {
    handleChangeAndBlur({
      value: event.target.value
        ? ({
            billingForecastPreOrderType: event.target.value,
            numberOfDays: null,
          } as OrderBillingForecastPreOrder)
        : null,
      name: 'billingForecastRuleForPreOrder',
    });
  };

  const handlePreOrderDaysBlur = () => {
    handleChangeAndBlur({
      value: {
        billingForecastPreOrderType:
          generalSettings.billingForecastRuleForPreOrder?.billingForecastPreOrderType,
        numberOfDays: preOrderDays,
      } as OrderBillingForecastPreOrder,
      name: 'billingForecastRuleForPreOrder',
    });
  };

  return {
    readyForDeliveryDays,
    preOrderDays,
    handleReadyForDeliveryTypeChange,
    handleReadyForDeliveryDaysChange,
    handleReadyForDeliveryDaysBlur,
    handlePreOrderTypeChange,
    handlePreOrderDaysChange,
    handlePreOrderDaysBlur,
  };
};

export default useOrderBillingForecast;
